import { styled } from '@mui/material/styles';

export const ActionsFooter = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-end',
  marginTop: theme.spacing(2)
}));

export const Column = styled('div')(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'row',
  padding: `${theme.spacing(1)} 0`
}));

export const Title = styled('div')(({ theme }) => ({
  fontSize: theme.fontSize.xsmall,
  minWidth: '35%'
}));

export const Value = styled('div')(({ theme }) => ({
  color: theme.color.primary.main,
  fontSize: theme.fontSize.large,
  textTransform: 'uppercase'
}));

export const Container = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  justifyContent: 'space-between'
}));

export const Content = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  whiteSpace: 'nowrap',
  [`& ${Column}`]: {
    flexGrow: 1
  },
  '@media (min-width: 678px)': {
    alignItems: 'flex-start',
    flexDirection: 'row',
    flexWrap: 'wrap',
    margin: theme.spacing(-2),
    overflow: 'hidden',
    [`& ${Column}`]: {
      alignItems: 'flex-start',
      flexDirection: 'column',
      flexGrow: 1,
      padding: `0 ${theme.spacing(2)}`,
      margin: `${theme.spacing(2)} 0`,
      boxShadow: `-1px 0 0 0 ${theme.color?.border || '#CCCCCC'}`
    },
    [`& ${Title}`]: {
      marginBottom: theme.spacing(1.5)
    }
  }
}));
